/* eslint-disable react/prop-types */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import LoadingMessage from "../../components/LoadingMessage/index";

import { setShortCode } from "../../duck/actions/organisation";
import ApiError from "../../util/ApiError";
import useOnMount from "../../hooks/useOnMount";
import useUserOrganisations from "../../hooks/useUserOrganisations";
import { logout } from "../login/duck/actions/login";
import { useHistoryState } from "../../hooks/useGlobalState";

const OrganisationAccess = ({ history }) => {
  const [{ redirect = "/" }] = useHistoryState();
  const { shortCode } = useParams();

  const dispatch = useDispatch();
  const organisations = useUserOrganisations();
  const user = useSelector((state) => state.loginReducer);

  const canAccessOrganisation =
    user.isAdmin || organisations?.some((org) => org.ShortCode === shortCode);

  async function setOrganisation() {
    await dispatch(setShortCode(shortCode));
    if (redirect && (redirect[0] === "#" || redirect[0] === "?")) {
      history.replace(`/${redirect}`);
    } else {
      history.replace(redirect);
    }
  }

  useOnMount(() => {
    if (canAccessOrganisation) {
      setOrganisation();
    }
  });

  if (!canAccessOrganisation) {
    throw new ApiError("You are not a user of this organisation", {
      log: false,
      action: {
        label: "Log in with another user",
        callback: () => {
          dispatch(
            logout(undefined, {
              redirectToLogin: true,
              loginState: { from: { pathname: `/o/${shortCode}${redirect}` } },
            }),
          );
        },
      },
    });
  }

  return <LoadingMessage center useLogoAnimation />;
};

export default OrganisationAccess;
